module.exports = "<div *ngIf=\"displayed\" class=\"red-color\">\n  {{ message | translate }}\n</div>\n"